import { useNavigate } from "react-router-dom";
import { CustomButton } from "../../components";
import styles from "./Selfie.module.scss";
import { useEffect } from "react";
import { googleEvent_LOJ221, googleEvent_LOJ223 } from "../../lib/google-analytics-loan-journey-events";
import { checkCameraPermission } from "../../lib/script";

export default function SelfiePermissionAllow() {
  const navigate = useNavigate();

  useEffect(() => {
    googleEvent_LOJ221();
  }, []);

  const handleCameraPermission = async () => {
    const permission = await checkCameraPermission();

    if (permission === "denied") {
      alert("Camera access is denied. Please follow the given instructions to enable it.");
    } else {
      navigate("/dashboard");
    }
  };

  // Detect browser
  const getBrowserName = () => {
    const userAgent = navigator.userAgent;
    if (userAgent.includes("Chrome") && !userAgent.includes("Edg")) return "Chrome";
    if (userAgent.includes("Edg")) return "Edge";
    if (userAgent.includes("Firefox")) return "Firefox";
    if (userAgent.includes("Safari") && !userAgent.includes("Chrome")) return "Safari";
    return "Browser";
  };

  const browser = getBrowserName();

  return (
    <div className={`wrapper ${styles.selfie__permission__page}`}>
      <img src="/images/no-camera.png" width="200" alt="" />
      <h2>Enable Camera Permission</h2>
      <p style={{ color: "red" }}>Camera access is denied. Please enable it in your browser settings.</p>
      <p style={{ fontSize: 14, fontWeight: "600", marginBottom: 0 }}>Instruct the User to Reset Permissions:</p>

      {browser === "Chrome" && (
        <ul className="text-left text-sm mb-1">
          <li>1. Click the 🔒 padlock icon in the address bar.</li>
          <li>
            2. Go to <b>Site settings</b>.
          </li>
          <li>
            3. Set 📷 <b>Camera → Allow</b>.
          </li>
          <li>4. Reload the page.</li>
        </ul>
      )}

      {browser === "Firefox" && (
        <ul className="text-left text-sm mb-1">
          <li>1. Look for a camera icon in the address bar.</li>
          <li>
            2. Click it and select <b>Allow</b>.
          </li>
          <li>3. Reload the page.</li>
        </ul>
      )}

      {browser === "Safari" && (
        <ul className="text-left text-sm mb-1">
          <li>
            1. Go to <b>Safari → Preferences → Websites → Camera</b>.
          </li>
          <li>
            2. Find this website and select <b>Allow</b>.
          </li>
          <li>3. Reload the page.</li>
        </ul>
      )}

      {browser === "Edge" && (
        <ul className="text-left text-sm mb-1">
          <li>1. Click the 🔒 padlock icon in the address bar.</li>
          <li>
            2. Go to <b>Permissions for this site</b>.
          </li>
          <li>
            3. Set 📷 <b>Camera → Allow</b>.
          </li>
          <li>4. Reload the page.</li>
        </ul>
      )}

      <br />

      <div className="mb-2">
        <CustomButton
          text="Yes, Permission Given"
          onClick={() => {
            googleEvent_LOJ223();
            handleCameraPermission();
          }}
        />
      </div>
    </div>
  );
}
